var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3381_70507)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#E4F3FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#0D70BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.75 9.625H16.4506L15.8117 8.66688C15.7775 8.61557 15.7311 8.5735 15.6768 8.54439C15.6224 8.51529 15.5617 8.50004 15.5 8.5H12.5C12.4383 8.50004 12.3776 8.51529 12.3232 8.54439C12.2689 8.5735 12.2225 8.61557 12.1883 8.66688L11.5489 9.625H10.25C9.95163 9.625 9.66548 9.74353 9.4545 9.9545C9.24353 10.1655 9.125 10.4516 9.125 10.75V16C9.125 16.2984 9.24353 16.5845 9.4545 16.7955C9.66548 17.0065 9.95163 17.125 10.25 17.125H17.75C18.0484 17.125 18.3345 17.0065 18.5455 16.7955C18.7565 16.5845 18.875 16.2984 18.875 16V10.75C18.875 10.4516 18.7565 10.1655 18.5455 9.9545C18.3345 9.74353 18.0484 9.625 17.75 9.625ZM18.125 16C18.125 16.0995 18.0855 16.1948 18.0152 16.2652C17.9448 16.3355 17.8495 16.375 17.75 16.375H10.25C10.1505 16.375 10.0552 16.3355 9.98484 16.2652C9.91451 16.1948 9.875 16.0995 9.875 16V10.75C9.875 10.6505 9.91451 10.5552 9.98484 10.4848C10.0552 10.4145 10.1505 10.375 10.25 10.375H11.75C11.8118 10.375 11.8726 10.3598 11.927 10.3307C11.9815 10.3016 12.0279 10.2595 12.0622 10.2081L12.7006 9.25H15.2989L15.9378 10.2081C15.9721 10.2595 16.0185 10.3016 16.073 10.3307C16.1274 10.3598 16.1882 10.375 16.25 10.375H17.75C17.8495 10.375 17.9448 10.4145 18.0152 10.4848C18.0855 10.5552 18.125 10.6505 18.125 10.75V16ZM14 11.125C13.5921 11.125 13.1933 11.246 12.8541 11.4726C12.515 11.6992 12.2506 12.0213 12.0945 12.3982C11.9384 12.7751 11.8975 13.1898 11.9771 13.5899C12.0567 13.99 12.2531 14.3575 12.5416 14.6459C12.83 14.9344 13.1975 15.1308 13.5976 15.2104C13.9977 15.29 14.4124 15.2491 14.7893 15.093C15.1662 14.9369 15.4883 14.6725 15.7149 14.3334C15.9415 13.9942 16.0625 13.5954 16.0625 13.1875C16.0619 12.6407 15.8444 12.1164 15.4577 11.7298C15.0711 11.3431 14.5468 11.1256 14 11.125ZM14 14.5C13.7404 14.5 13.4867 14.423 13.2708 14.2788C13.055 14.1346 12.8867 13.9296 12.7874 13.6898C12.6881 13.4499 12.6621 13.186 12.7127 12.9314C12.7634 12.6768 12.8884 12.443 13.0719 12.2594C13.2555 12.0759 13.4893 11.9509 13.7439 11.9002C13.9985 11.8496 14.2624 11.8756 14.5023 11.9749C14.7421 12.0742 14.9471 12.2425 15.0913 12.4583C15.2355 12.6742 15.3125 12.9279 15.3125 13.1875C15.3125 13.5356 15.1742 13.8694 14.9281 14.1156C14.6819 14.3617 14.3481 14.5 14 14.5Z",
    fill: "#005596"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3381_70507",
    x: 0,
    y: 0,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3381_70507"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3381_70507",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraButton);
export default __webpack_public_path__ + "static/media/cameraButton.e9381ad4a8400173046d74fe9e1918a9.svg";
export { ForwardRef as ReactComponent };